/**
 * All fields here are free (Basic tier). Contact and Atmosphere fields are never requested.
 *
 * See https://developers.google.com/maps/documentation/places/web-service/legacy/place-data-fields#basic
 */
export const basicFields = [
  'address_component',
  'formatted_address',
  'geometry.viewport',
  'geometry.location',
  'name',
  'place_id',
  'type',
  'vicinity',
];
